type TRowProps = {
  /**
   * The id of the row.
   * This is used to uniquely identify the row.
   * If not provided, index of the row will be used as id.
   */
  id?: string;
  children: React.ReactNode;
  row: Record<string, any>;
};

export const TRow = ({ children }: TRowProps) => {
  return <>{children}</>;
};
